/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Ban_Members_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to permanently ban and delete the message history of other members from this server." |
*
* @param {Leveling_Perm_Ban_Members_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_ban_members_hint = /** @type {((inputs?: Leveling_Perm_Ban_Members_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Ban_Members_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам навсегда банить других участников и удалять их историю сообщений на этом сервере.")
	return /** @type {LocalizedString} */ ("Allows members to permanently ban and delete the message history of other members from this server.")
});